import React from 'react';
import { ArrowUpIcon, ICON_COLOR } from '@zep-us/zus';
import { cn } from '@/utils';
import { type PresetTopic } from '../types';
type PresetChipsProps = {
  presets: PresetTopic[];
  onPresetClick: (preset: PresetTopic) => void;
};
export const PresetChips: React.FC<PresetChipsProps> = ({
  presets,
  onPresetClick
}) => {
  return <div className="flex w-full flex-col items-start gap-3xs tablet-sm:gap-2xs" data-sentry-component="PresetChips" data-sentry-source-file="PresetChips.tsx">
      {presets.map(preset => <div key={preset.topicId} onClick={() => onPresetClick(preset)} className={cn('flex items-start gap-sm w-full max-w-[1080px] cursor-pointer', 'py-xs px-md tablet-sm:px-2xl tablet-sm:py-xs', 'rounded-md', 'hover:bg-neutral transition-colors')}>
          {/* ArrowUp Icon */}
          <ArrowUpIcon fill={ICON_COLOR.neutral} className="size-[20px] flex-shrink-0 tablet-sm:size-[28px]" />

          {/* Text */}
          <p className="text-body-lg-bold text-neutral tablet-sm:text-heading-md-bold">
            {preset.label}
          </p>
        </div>)}
    </div>;
};